import commonRepo from '@/repository/common.repo'
import { typeSafeAssign } from '@/utils/common'
import { makeAutoObservable, makeObservable, observable } from 'mobx'

export type ContractInfo = {
  academyId: res.B2gContract['academyId'] | null
  schoolName: string
  amount: res.B2gContract['amount']
  contractStartDateTime: res.B2gContract['contractStartDateTime']
  contractEndDateTime: res.B2gContract['contractEndDateTime']
  subscribePlan: res.B2gContract['subscribePlan'] | null
  studentCount: res.B2gContract['studentCount']
  teacherSignature?: req.B2gSignature['teacherSignature']
  schoolNameSignature?: req.B2gSignature['teacherSignature']
}

export class ContractPdfService {
  contractInfo: ContractInfo = {
    academyId: commonRepo.b2gContract?.academyId || null,
    schoolName: commonRepo.b2gContract?.schoolName || '',
    amount: commonRepo.b2gContract?.amount || 0,
    subscribePlan: commonRepo.b2gContract?.subscribePlan || null,
    studentCount: commonRepo.b2gContract?.studentCount || 0,
    contractStartDateTime: commonRepo.b2gContract?.contractStartDateTime || null,
    contractEndDateTime: commonRepo.b2gContract?.contractEndDateTime || null,
    teacherSignature: '',
    schoolNameSignature: '',
  }
  contractPdfInfo?: ContractInfo
  pdfClient: { connected: boolean } = {
    connected: false,
  }
  constructor(data?: Partial<ContractPdfService>) {
    if (data) typeSafeAssign(this, data)
    makeAutoObservable(this)
  }
  get pdfDataRenderData() {
    return {
      ...this.contractInfo,
    }
  }
}
